import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ChangePasswordModal from './ChangePasswordModal';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <nav className="shrink-0 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-4">
            <img
              src="/logo.png"
              alt="Company Logo"
              className="h-8"
            />
            <span className="text-xl font-semibold text-gray-800">
              {user?.role === 'admin' ? 'Admin Dashboard' : 'SMS Dashboard'}
            </span>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-gray-600">{user?.username}</span>
            {/* Available to every signed-in user, admin or not */}
            <button
              onClick={() => setShowChangePassword(true)}
              className="px-3 py-2 text-sm font-medium text-[#41525d] hover:text-[#00a884] focus:outline-none"
              title="Change your password"
            >
              Change Password
            </button>
            <button
              onClick={logout}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </nav>
  );
};

export default Navbar;
